import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-badge',
	imports: [SharedModule],
	templateUrl: './badge.component.html',
	styleUrl: './badge.component.scss',
})
export class BadgeComponent {
	@Input() value: string | number = '';
	@Input() badgeSize: 'small' | 'large' | 'xlarge' = 'small';
	@Input() severity: 'info' | 'success' | 'warn' | 'danger' | 'secondary' | 'contrast' = 'danger';
}
